const KEY_MAP_KEY = {
  ENTER : 'ENTER'
}

const KEY_MAP = {
  [KEY_MAP_KEY.ENTER] : 'Enter'
};

export {
  KEY_MAP_KEY
};

export default KEY_MAP;
